export function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }


  export function formatTime(dateString) {
  const date = new Date(dateString);
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  const formattedHours = hours.toString().padStart(2, '0');
  const formattedTime = `${formattedHours}:${minutes}:${seconds} ${ampm}`;
  return `${formattedTime}`;
}
  


 export  const normalizeDate = (dateString) => {
  if (!dateString) return '';
  // Replace slashes with dashes
  let formatted = dateString.includes('/') ? dateString.replaceAll('/', '-') : dateString;

  // Ensure it's in YYYY-MM-DD format
  const date = new Date(formatted);
  if (isNaN(date)) return '';
  return date.toISOString().split('T')[0];
};


export  const formattedName = (value) => {
    if (!value) return ''; // Handle null or undefined values

    // Convert to lowercase and capitalize the first letter of each word
    return value
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };